import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getSchedule,
  upsertShift,
  deleteShift,
  fetchRotationConfig,
  updateRotationConfig,
} from '../api/client';

export function useSchedule(start: string, weeks: number) {
  return useQuery({
    queryKey: ['admin', 'schedule', start, weeks],
    queryFn: () => getSchedule(start, weeks),
    staleTime: 30 * 1000,
  });
}

export function useUpsertShift() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ weekStart, assigneeEmail, assigneeName }: {
      weekStart: string;
      assigneeEmail: string;
      assigneeName: string;
    }) => upsertShift(weekStart, assigneeEmail, assigneeName),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'schedule'] });
    },
  });
}

export function useDeleteShift() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (weekStart: string) => deleteShift(weekStart),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'schedule'] });
    },
  });
}

export function useRotationConfig() {
  return useQuery({
    queryKey: ['admin', 'schedule', 'rotation'],
    queryFn: fetchRotationConfig,
    staleTime: 30 * 1000,
  });
}

export function useUpdateRotationConfig() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (config: {
      enabled: boolean;
      members: Array<{ email: string; name: string }>;
      startDate: string;
      periodDays: number;
    }) => updateRotationConfig(config),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'schedule'] });
    },
  });
}
